import { useEffect, useState } from "react";
import { GAME, STORE_URL, ASSETS } from "../data/content";

const NAV_LINKS = [
  { id: "hunt", label: "Wildlife" },
  { id: "bullets", label: "Arsenal" },
  { id: "screens", label: "Features" },
  { id: "site-footer", label: "Community" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, id) => {
    e.preventDefault();
    const el =
      document.getElementById(id) ||
      document.querySelector(`[data-testid="${id}"]`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-6 lg:px-10 transition-all duration-500 ${
          scrolled ? "glass rounded-full" : "border-b border-transparent"
        }`}
      >
        <div className="flex items-center justify-between gap-6 py-2">
          <a
            href="#top"
            data-testid="brand-link"
            className="flex items-center gap-3 group shrink-0"
          >
            <img
              src={ASSETS.appIcon}
              alt=""
              aria-hidden="true"
              className="h-10 w-10 rounded-md object-cover ring-1 ring-white/15"
              draggable="false"
            />
            <div className="font-display text-xl text-white tracking-wide">
              {GAME.name}
            </div>
          </a>

          {/* Section nav — desktop */}
          <nav
            data-testid="site-nav"
            className="hidden md:flex items-center gap-7 lg:gap-9"
          >
            {NAV_LINKS.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={(e) => handleNav(e, n.id)}
                data-testid={`nav-${n.id}`}
                className="text-[12px] uppercase tracking-[0.22em] text-white/65 hover:text-white transition-colors duration-300 font-body font-medium"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <a
            href={STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-download-btn"
            onClick={() => {
              import("../lib/analytics").then((m) =>
                m.trackOutboundClick("header-download-btn", STORE_URL, {
                  placement: "header",
                })
              );
            }}
            className="scope-halo inline-flex items-center gap-2 rounded-full bg-[hsl(var(--primary))] px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[hsl(var(--primary))]/20 hover:bg-[hsl(var(--primary))]/90 transition-all duration-300 shrink-0"
          >
            Download
            <span aria-hidden className="text-base leading-none">→</span>
          </a>
        </div>
      </div>
    </header>
  );
}
